module.exports = __webpack_public_path__ + "static/media/infoJumbo2.c80322ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/demmeler/images/infoJumbo2.jpg
// module id = 477
// module chunks = 0